export default __webpack_public_path__ + "static/media/baby-signing.56df8660.svg";